import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable CRA's runtime error overlay in development. CORS-blocked
// "Script error." events from third-party scripts (PostHog / Emergent
// platform helper) keep tripping it. Compile/build errors still surface
// via webpack's separate channel; genuine runtime errors still log to
// the console, they just don't flash a full-screen red panel.
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line global-require
  try {
    const ErrorOverlay = require("react-error-overlay");
    if (ErrorOverlay && typeof ErrorOverlay.stopReportingRuntimeErrors === "function") {
      ErrorOverlay.stopReportingRuntimeErrors();
    }
  } catch (_) { /* package not installed, no-op */ }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
